import { existingLegacyEventHub } from '~/modules/legacyRuntime.js';
const TrackShowLicenseTrigger = {
  initialized: false,

  init() {
    if (this.initialized || typeof document === 'undefined') {
      return;
    }

    document.addEventListener('click', this.handleDocumentClick);
    this.initialized = true;
  },

  destroy() {
    if (!this.initialized || typeof document === 'undefined') {
      return;
    }

    document.removeEventListener('click', this.handleDocumentClick);
    this.initialized = false;
  },

  handleDocumentClick(event) {
    const trigger = event.target && typeof event.target.closest === 'function'
      ? event.target.closest('[data-track-license-select-trigger]')
      : null;

    if (!trigger) {
      return;
    }

    const eventHub = existingLegacyEventHub();
    if (!eventHub || typeof eventHub.trigger !== 'function') {
      return;
    }

    const trackId = trigger.getAttribute('data-track-id');
    if (!trackId) {
      return;
    }

    event.preventDefault();
    eventHub.trigger('openTrackUsageLicenseSelect', { trackId: trackId });
  }
};

TrackShowLicenseTrigger.handleDocumentClick = TrackShowLicenseTrigger.handleDocumentClick.bind(TrackShowLicenseTrigger);

export default TrackShowLicenseTrigger;
